import { Accordion, Badge, NavLink } from "@mantine/core";
import { getMenuStats, safeApiCall } from "api/common.service";
import {
  AdminNavLinks,
  CountableDEMenuLabel,
  CountableMenuLabel,
} from "pages/NavLinks";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MenuStats } from "types/model.types";

const StockSystemSideBar = () => {
  const location = useLocation();
  const [data, setData] = useState<MenuStats | null>(null);
  // Find which accordion group contains the current route
  let activeGroup = AdminNavLinks.find((group) =>
    group.items.some((item) => item.href === location.pathname),
  )?.label;

  // Fallback for /admin or any unmatched route
  if (!activeGroup) {
    activeGroup = "Debtors";
  }

  useEffect(() => {
    // this effect will query the database to get a count of open orders, suppliers, customers etc and update the badge count
    let mounted = true;

    const fetchStats = async () => {
      const stats = await safeApiCall(getMenuStats());
      if (mounted) {
        setData(stats.data?.[0]);
      }
    };

    fetchStats();

    return () => {
      mounted = false;
    };
  }, [location.pathname]);

  const stats: Record<CountableMenuLabel, number> = {
    Debtors: data?.totalAccounts ?? 0,
    "Data Entry":
      (data?.totalOrders ?? 0) +
      (data?.totalPayments ?? 0) +
      (data?.totalCrNote ?? 0) +
      (data?.totalCrJnl ?? 0) +
      (data?.totalDbJnl ?? 0),
    Suppliers: data?.totalSupplierOrders ?? 0,
  };
  // data entry stats
  const deStats: Record<CountableDEMenuLabel, number> = {
    "Order Management": data?.totalOrders ?? 0,
    Payments: data?.totalPayments ?? 0,
    "Credit Notes": data?.totalCrNote ?? 0,
    "Credit Journals": data?.totalCrJnl ?? 0,
    "Debit Journals": data?.totalDbJnl ?? 0,
    "Supplier Ordering": data?.totalSupplierOrders ?? 0,
  };

  return (
    <>
      <Accordion defaultValue={activeGroup}>
        {AdminNavLinks.map(({ label, icon, items }) => (
          <Accordion.Item key={label} value={label}>
            <Accordion.Control icon={icon}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <span>{label}</span>
                {label in stats && stats[label as CountableMenuLabel] > 0 && (
                  <Badge color="blue" size="sm">
                    {stats[label as CountableMenuLabel]}
                  </Badge>
                )}
              </div>
            </Accordion.Control>

            <Accordion.Panel>
              {items.map(({ label: itemLabel, icon: Icon, href }) => (
                <NavLink
                  key={itemLabel}
                  label={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span>{itemLabel}</span>

                      {itemLabel in deStats &&
                        deStats[itemLabel as CountableDEMenuLabel] > 0 && (
                          <Badge color="blue" size="sm">
                            {deStats[itemLabel as CountableDEMenuLabel]}
                          </Badge>
                        )}
                    </div>
                  }
                  title={href}
                  leftSection={<Icon size={16} stroke={1.5} />}
                  component={Link}
                  to={href}
                  active={location.pathname === href}
                  style={{
                    textDecoration: "none",
                    color: location.pathname === href ? "#1c7ed6" : "black",
                    fontWeight: location.pathname === href ? "bold" : "normal",
                  }}
                />
              ))}
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </>
  );
};

export default StockSystemSideBar;
